export default {"src":"/_next/static/media/ico7.ec46090c.svg","height":43,"width":19,"blurWidth":0,"blurHeight":0};